import getCurrentGameSelected from '../../shares/lib/currentGameSelected';
import { getGameLaunchUrl } from '../gameLauncherUrl';
import logger from '../../shares/lib/logger';
import { LogiSDKConfig } from '../../shares/model/config';

const playForFunGame = (swipeSDKConfig: LogiSDKConfig) => {
  try {
    const currentGameselected = getCurrentGameSelected();

    if (!currentGameselected || !currentGameselected.currentGameId) {
      logger.error('No current game selected or missing game ID');
      return null;
    }

    const gameLaunchUrl = getGameLaunchUrl(
      swipeSDKConfig?.swipeGames?.gameLaunchConfig as never,
      currentGameselected.currentGameId,
    );

    if (!gameLaunchUrl) {
      logger.error('Failed to generate game launch URL');
      return null;
    }

    logger.info(`Game launch URL for fun mode: ${gameLaunchUrl}`);
    return gameLaunchUrl;
  } catch (error) {
    logger.error('Error in playForFunGame', { error });
    return null;
  }
};

export default playForFunGame;
